import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { PageModel } from '@/domains/seek/models/page-model';

export interface IsInAgentService {
    isInAgent(): boolean;
}

export const IsInAgentService = Symbol('IsInAgentService');

@injectable()
export class IsInAgentServiceImpl implements IsInAgentService {
    constructor(
        @inject(PageModel)
        private _pageModel: PageModel
    ) {
    }

    public isInAgent() {
        return !!this._pageModel.modelData._in_agent;
    }
}
